import { render, staticRenderFns } from "./WebcamPanel.vue?vue&type=template&id=3cc3364d&scoped=true&"
import script from "./WebcamPanel.vue?vue&type=script&lang=js&"
export * from "./WebcamPanel.vue?vue&type=script&lang=js&"
import style0 from "./WebcamPanel.vue?vue&type=style&index=0&id=3cc3364d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc3364d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VCard,VCardText,VCardTitle,VResponsive})
